<script lang="ts">
    import './WidgetTemplate.css';
    import { type DashboardComponentType, WidgetManager } from './WidgetManager';

    export let dashboardItem: DashboardComponentType | undefined = undefined;
    export let widgetManager: WidgetManager;

    $: console.log('WidgetTemplate settings', dashboardItem?.settings);
</script>

<div class="widget-window">
    {#if typeof dashboardItem !== 'undefined'}
        <div class="sortable-item-handle no-print"></div>
    {/if}
    {#if typeof dashboardItem !== 'undefined'}
        <div
            class="icon-settings-container no-print visible"
            on:click={() => {
                widgetManager.onSettingsClick(dashboardItem, () => {
                    widgetManager = widgetManager;
                });
            }}
        ></div>
    {/if}
    <div class="widget-body">
        <slot />
    </div>
</div>

<style>
    .widget-window {
        display: flex;
        flex-direction: column;
    }
    .widget-window .widget-body {
        flex: 1 0 auto;
        display: flex;
        flex-direction: column;
    }
</style>
